import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import WhatIsSection from './components/WhatIsSection';
import WhyChooseSection from './components/WhyChooseSection';
import ArticlePreview from './components/ArticlePreview';
import SafetySection from './components/SafetySection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const navigate = useNavigate();

  const scrollTo = useCallback((id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  const handleCategoryClick = useCallback(() => scrollTo('kategorie'), [scrollTo]);
  const handleSafetyClick = useCallback(() => scrollTo('bezpieczenstwo'), [scrollTo]);
  const handleFaqClick = useCallback(() => scrollTo('faq'), [scrollTo]);
  const handleArticleClick = useCallback(() => {
    navigate('/artykul/kakobuy-spreadsheet-kompletny-przewodnik');
  }, [navigate]);

  return (
    <>
      <Navbar
        onCategoryClick={handleCategoryClick}
        onSafetyClick={handleSafetyClick}
        onFaqClick={handleFaqClick}
        onArticleClick={handleArticleClick}
      />

      <main>
        <HeroSection
          onCategoryClick={handleCategoryClick}
          onArticleClick={handleArticleClick}
        />
        <CategorySection />
        <WhatIsSection />
        <WhyChooseSection />
        <ArticlePreview />
        <SafetySection />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}